import React from 'react';
import PropTypes from 'prop-types';
import { SFServices, SFConnection, SFNotification } from 'utils/types';
import SearchBarContainerWithRouter from './searchBar/SearchBarContainerWithRouter';
import ServicesContainer from './services/ServicesContainer';
import ConnectionsContainer from './connections/ConnectionsContainer';
import css from './ServiceCatalogContainer.scss';
import { withNotification } from '../../common/withNotification';
import Announcement from "../../systemAnnouncement/Announcement";

class ServiceCatalogContainer extends React.Component {

  get displayStudentAnnouncement() {
    return this.props.studentAnnouncementEnabled && this.props.isStudent;
  }

  get greeting() {
    return this.props.isStudent ? <h1>How can we help?</h1> : null;
  }

  get emptyText() {
    return !this.props.canSeeSuccessNetwork && !this.props.canSeeServices
      ? <p>You do not currently have any connections. When we connect you with services and staff resources, you will see them here.</p>
      : null;
  }

  get connections() {
    const { isStudent, canSeeSuccessNetwork, connections, onConnectionsFetched } = this.props;
    return isStudent && canSeeSuccessNetwork
      ? <ConnectionsContainer
          connections={connections}
          onConnectionsFetched={onConnectionsFetched}
          onFailure={this.props.notification.error}
        />
      : null;
  }

  get services() {
    return this.props.canSeeServices
      ? <ServicesContainer
          services={this.props.services}
          onServicesFetched={this.props.onServicesFetched}
          isStudent={this.props.isStudent}
          isStaff={this.props.isStaff}
          isServiceMember={this.props.isServiceMember}
          canSeeStudentServices={this.props.canSeeStudentServices}
          canMakeAppointment={this.props.canMakeAppointment}
          hasConnectLicense={this.props.hasConnectLicense}
          onFailure={this.props.notification.error}
          responsiveKioskEnabled={this.props.responsiveKioskEnabled}
          virtualCheckInEnabled={this.props.virtualCheckInEnabled}
        />
      : null;
  }

  render() {
    return (
      <div>
        {this.props.notification.render()}
        {this.displayStudentAnnouncement && <Announcement
          studentAnnouncementEnabled={this.props.studentAnnouncementEnabled} />}
        <SearchBarContainerWithRouter
          results={this.props.searchResults}
          onResultsFetched={this.props.onResultsFetched}
          value={this.props.searchQuery}
          isStudent={this.props.isStudent}
          onSearchChange={this.props.onSearchChange}
          onFailure={this.props.notification.error}
        />
        <div className={css['container']}>
          {this.greeting}
          {this.emptyText}
          {this.connections}
          {this.services}
        </div>
      </div>
    );
  }
}

ServiceCatalogContainer.propTypes = {
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  canSeeSuccessNetwork: PropTypes.bool.isRequired,
  canSeeServices: PropTypes.bool.isRequired,
  canSeeStudentServices: PropTypes.bool.isRequired,
  canMakeAppointment: PropTypes.bool.isRequired,
  studentAnnouncementEnabled: PropTypes.bool.isRequired,
  hasConnectLicense: PropTypes.bool.isRequired,
  services: SFServices.isRequired,
  onServicesFetched: PropTypes.func.isRequired,
  connections: PropTypes.arrayOf(PropTypes.shape(SFConnection)).isRequired,
  onConnectionsFetched: PropTypes.func.isRequired,
  searchResults: PropTypes.object.isRequired,
  onResultsFetched: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  notification: SFNotification.isRequired,
  responsiveKioskEnabled: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool,
};

export default withNotification(ServiceCatalogContainer);
